import { API_Error, API_Response } from "@/interfaces/api/response/api_response_types"
import { CreateCheckoutData, CustomerPortalLinkData } from "@/interfaces/api/stripe/api_request_types"
import { API_Data_CreateCheckout_Response, API_Data_Customer_Portal_Link_Response } from "@/interfaces/api/stripe/api_response_types"
import { fetcher } from "@/utils/helpers"

/*
==================
      STRIPE
==================
*/

/**
 * Edits a self's data on the server
 * 
 * @param param0 - An object that contains the profileId and a payload with the data to be sent to the server
 * @returns - Returns the data of the edited profile
 */
export async function getCustomerPortalLink (payload: CustomerPortalLinkData): Promise<API_Data_Customer_Portal_Link_Response> {
  const res = await fetcher(`/api/stripe/self/portal`, { 
    method: 'POST',
    cache: "no-store",
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload)
  })

  const response = await res.json() as API_Response<API_Data_Customer_Portal_Link_Response>

  if (!res.ok) throw { code: res.status, description: 'Unknow customer portal link error' } as API_Error
  if (response.status === 'error') throw response.error
  if (!response.data) throw { code: 500, description: 'Customer portal link data missing in response' } as API_Error

  return response.data
}

export async function createCheckout({ price_id, success_url, cancel_url, discount_code }: CreateCheckoutData): Promise<API_Data_CreateCheckout_Response> {
  const res = await fetcher(`/api/stripe/checkout`, { 
    method: 'POST',
    cache: "no-store",
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ 
      price_id, 
      success_url, 
      cancel_url,
      ...(discount_code ? { discount_code } : {})
    })
  })

  const response = await res.json() as API_Response<API_Data_CreateCheckout_Response>

  if (!res.ok) throw { code: res.status, description: 'Unknow create checkout error' } as API_Error
  if (response.status === 'error') throw response.error
  if (!response.data) throw { code: 500, description: 'Checkout data missing in response' } as API_Error

  return response.data
}